import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { Flex, Text } from 'pcln-design-system'

import { TIERS } from '../constants'
import { VIP_COLORS } from '../colorVariations'
import { VipIcon } from '../svgr/icons'

const TierTitle = styled(Text)`
  text-transform: uppercase;
`

export const SIZES_HORIZONTAL = {
  small: {
    iconFontSize: '24px',
    fontSize: '12px',
  },
  medium: {
    iconFontSize: '32px',
    fontSize: '14px',
  },
  large: {
    iconFontSize: '40px',
    fontSize: '16px',
  },
}
export const SIZES_STACKED = {
  small: {
    iconFontSize: '32px',
    fontSize: '12px',
  },
  medium: {
    iconFontSize: '48px',
    fontSize: '14px',
  },
  large: {
    iconFontSize: '64px',
    fontSize: '16px',
  },
}

export const getBadgeSizes = ({ layout, size }) => {
  if (layout === 'stacked') {
    return SIZES_STACKED?.[size] || SIZES_STACKED.large
  }

  return SIZES_HORIZONTAL?.[size] || SIZES_HORIZONTAL.large
}
export const getTextColor = (colorName) => VIP_COLORS?.[colorName] || VIP_COLORS.member

export const getTextMarginProps = ({ layout }) => (layout !== 'stacked' ? { ml: 2 } : { mt: 2 })

const TierBadge = ({ layout = 'horizontal', level = 'member', size = 'large', className, ...props }) => {
  const { iconFontSize, fontSize } = getBadgeSizes({ layout, size })
  const textColor = getTextColor(level)
  const flexDirection = layout !== 'stacked' ? 'row' : 'column'
  const textMarginProps = getTextMarginProps({ layout })

  return (
    <Flex
      alignItems='center'
      justifyContent='center'
      flexDirection={flexDirection}
      className={className}
      {...props}
    >
      <VipIcon fontSize={iconFontSize} title='Priceline VIP logo' />

      <TierTitle {...textMarginProps} fontSize={fontSize} fontWeight='bold' color={textColor}>
        {level}
      </TierTitle>
    </Flex>
  )
}
TierBadge.propTypes = {
  layout: PropTypes.oneOf(['horizontal', 'stacked']),
  level: PropTypes.oneOf(TIERS),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  className: PropTypes.string,
}

export default TierBadge
